module.exports = __webpack_public_path__ + "static/media/Aldsworth Kitchen (4).46ea96fc.JPG";